// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../common/components/authenticated-page';
import React from 'react';
import UnitsPage from './components/unitsPage';

const SelectUnitsPage = props => (

    <AuthenticatedPage className="units-page">
        <UnitsPage {...props} />
    </AuthenticatedPage>

);

export default SelectUnitsPage;
